export class ForgotPassword
{
    public username: string;
    public password: string;
    public email: string;
}
